"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));
var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _SttContainerTitle = _interopRequireDefault(require("../SttTypography/SttContainerTitle"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _SttHeading = _interopRequireDefault(require("../SttTypography/SttHeading"));
var _core = require("@stt-componentes/core");
var _SttModal = _interopRequireDefault(require("../SttModal"));
var _SttNotification = _interopRequireDefault(require("../SttNotification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: function wrapper(props) {
      var _ref;
      return _ref = {}, _defineProperty(_ref, theme.breakpoints.up('sm'), {
        height: props.estaEmIframe ? 'auto' : props.possuiTabHeader ? 'calc(100vh - 220px)' : 'calc(100vh - 140px)'
      }), _defineProperty(_ref, "flexDirection", 'row'), _defineProperty(_ref, "display", 'flex'), _defineProperty(_ref, "overflow", 'auto'), _ref;
    },
    leftBox: function leftBox(props) {
      var _ref2;
      return _ref2 = {
        height: '100%',
        width: props.esconderTabsEsquerda ? 0 : '240px',
        overflow: 'hidden'
      }, _defineProperty(_ref2, theme.breakpoints.up('lg'), {
        width: props.esconderTabsEsquerda ? 0 : '280px'
      }), _defineProperty(_ref2, theme.breakpoints.up('xl'), {
        width: props.esconderTabsEsquerda ? 0 : '320px'
      }), _defineProperty(_ref2, theme.breakpoints.up('md'), {
        width: props.esconderTabsEsquerda ? 0 : '250px'
      }), _defineProperty(_ref2, theme.breakpoints.down('sm'), {
        width: 0
      }), _ref2;
    },
    rigthBox: function rigthBox(props) {
      var _ref3;
      return _ref3 = {
        height: '100%',
        width: props.esconderTabsEsquerda ? '100%' : 'calc(100% - 240px)'
      }, _defineProperty(_ref3, theme.breakpoints.up('lg'), {
        width: props.esconderTabsEsquerda ? '100%' : 'calc(100% - 280px)'
      }), _defineProperty(_ref3, theme.breakpoints.up('xl'), {
        width: props.esconderTabsEsquerda ? '100%' : 'calc(100% - 320px)'
      }), _defineProperty(_ref3, theme.breakpoints.up('md'), {
        width: props.esconderTabsEsquerda ? '100%' : 'calc(100% - 250px)'
      }), _defineProperty(_ref3, theme.breakpoints.down('sm'), {
        width: '100%'
      }), _defineProperty(_ref3, "display", 'flex'), _defineProperty(_ref3, "flexDirection", 'column'), _ref3;
    },
    content: {
      flexGrow: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(0)
    },
    contentWithAside: {
      flexGrow: 1,
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    lateralContent: _defineProperty({
      position: 'relative'
    }, theme.breakpoints.down('sm'), {
      display: 'none'
    }),
    fabPreVisualizacao: _defineProperty({
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      zIndex: 10
    }, theme.breakpoints.up('md'), {
      display: 'none'
    }),
    fixedHeader: {
      position: 'sticky',
      padding: theme.spacing(1),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      top: 0,
      zIndex: 1
    },
    listItemSelected: {
      "&.Mui-selected": {
        backgroundColor: (0, _colorManipulator.alpha)(theme.palette.primary.main, 0.1),
        borderRadius: theme.spacing(1)
      }
    },
    listItemRoot: {
      color: theme.palette.primary.main
    },
    listItemText: {
      fontSize: '1rem'
    },
    listItemTextSelected: {
      fontWeight: 'bold'
    },
    alert: {
      marginBottom: theme.spacing(1)
    },
    notification: {
      display: 'flex',
      flexDirection: 'column'
    }
  };
});
var SttContentDrawer = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var titulo = props.titulo,
    botaoAcoes = props.botaoAcoes,
    _props$onClickVoltar = props.onClickVoltar,
    onClickVoltar = _props$onClickVoltar === void 0 ? null : _props$onClickVoltar,
    _props$botoes = props.botoes,
    botoes = _props$botoes === void 0 ? null : _props$botoes,
    _props$conteudo = props.conteudo,
    conteudo = _props$conteudo === void 0 ? [] : _props$conteudo,
    _props$conteudoLatera = props.conteudoLateral,
    conteudoLateral = _props$conteudoLatera === void 0 ? null : _props$conteudoLatera,
    _props$secoesErro = props.secoesErro,
    secoesErro = _props$secoesErro === void 0 ? [] : _props$secoesErro,
    _props$notificacaoSup = props.notificacaoSuperior,
    notificacaoSuperior = _props$notificacaoSup === void 0 ? null : _props$notificacaoSup,
    _props$formRef = props.formRef,
    formRef = _props$formRef === void 0 ? null : _props$formRef,
    _props$possuiTabHeade = props.possuiTabHeader,
    possuiTabHeader = _props$possuiTabHeade === void 0 ? true : _props$possuiTabHeade,
    _props$esconderTabsEs = props.esconderTabsEsquerda,
    esconderTabsEsquerda = _props$esconderTabsEs === void 0 ? false : _props$esconderTabsEs,
    _props$estaEmIframe = props.estaEmIframe,
    estaEmIframe = _props$estaEmIframe === void 0 ? false : _props$estaEmIframe;
  var classes = useStyles({
    possuiTabHeader: possuiTabHeader,
    esconderTabsEsquerda: esconderTabsEsquerda,
    estaEmIframe: estaEmIframe
  });
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    modalPreVisualizacao = _useState4[0],
    setModalPreVisualizacao = _useState4[1];
  var contentRefs = (0, _react.useRef)({});
  var scrollTimeout = (0, _react.useRef)(null);
  var isUserScrolling = (0, _react.useRef)(true);
  var contentElementRef = (0, _react.useRef)(null);
  var handleItemClick = (0, _react.useCallback)(function (index, id, onClick) {
    isUserScrolling.current = false;
    setSelectedTab(index);
    onClick === null || onClick === void 0 ? void 0 : onClick();
    var targetDiv = contentRefs.current[id];
    if (targetDiv) {
      targetDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setTimeout(function () {
        isUserScrolling.current = true;
      }, 500);
    }
  }, []); // Memoized to avoid re-creation

  var handleScroll = (0, _react.useCallback)(function () {
    if (!isUserScrolling.current) return;
    clearTimeout(scrollTimeout.current);
    scrollTimeout.current = setTimeout(function () {
      var _contentElementRef$cu;
      var contentKeys = Object.keys(contentRefs.current);
      var boxTop = (_contentElementRef$cu = contentElementRef.current) === null || _contentElementRef$cu === void 0 ? void 0 : _contentElementRef$cu.getBoundingClientRect().top;
      var proximaTab = selectedTab;
      if (boxTop !== undefined) {
        for (var i = 0; i < contentKeys.length; i++) {
          var element = contentRefs.current[contentKeys[i]];
          if (element) {
            var _element$getBoundingC = element.getBoundingClientRect(),
              top = _element$getBoundingC.top,
              bottom = _element$getBoundingC.bottom;
            if (top <= boxTop + 100 && bottom > boxTop + 100) {
              proximaTab = i;
              break;
            }
          }
        }
        var container = contentElementRef.current;
        if (container && Math.ceil(container.scrollTop + container.clientHeight) >= container.scrollHeight - 1) {
          proximaTab = contentKeys.length - 1;
        }
      }
      if (proximaTab !== selectedTab) setSelectedTab(proximaTab);
    }, 100);
  }, [selectedTab]); // Memoized to avoid re-creation

  (0, _react.useEffect)(function () {
    var contentElement = contentElementRef.current;
    if (contentElement) {
      contentElement.addEventListener('scroll', handleScroll);
    }
    return function () {
      if (contentElement) {
        contentElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);
  var verificarSecoesComErro = (0, _react.useCallback)(function (validateForm) {
    validateForm().then(function (errors) {
      isUserScrolling.current = false;
      var firstErrorSection = secoesErro.find(function (section) {
        return errors[section];
      });
      if (firstErrorSection) {
        var targetDiv = contentRefs.current[firstErrorSection];
        if (targetDiv) {
          var contentKeys = Object.keys(contentRefs.current);
          var index = contentKeys.findIndex(function (key) {
            return key === firstErrorSection;
          });
          setSelectedTab(index || 0);
          targetDiv.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          setTimeout(function () {
            isUserScrolling.current = true;
          }, 500);
        }
      }
    });
  }, [secoesErro]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      verificarSecoesComErro: verificarSecoesComErro
    };
  });
  var filteredConteudo = conteudo.filter(function (item) {
    return item.show;
  });
  var conteudoMain = /*#__PURE__*/_react["default"].createElement("main", {
    className: classes.content,
    ref: contentElementRef
  }, filteredConteudo.map(function (item, index) {
    if (!item.id) {
      item.id = item.titulo;
    }
    return item.show && /*#__PURE__*/_react["default"].createElement("div", {
      key: item.id,
      id: item.id,
      ref: function ref(el) {
        return contentRefs.current[item.id] = el;
      },
      tabIndex: -1
    }, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h3",
      style: {
        marginTop: 10,
        marginBottom: 10
      }
    }, item.titulo), item.children, index < filteredConteudo.length - 1 && /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
      style: {
        marginTop: 10
      }
    }));
  }));
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.wrapper
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.leftBox
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    component: "nav"
  }, filteredConteudo.map(function (item, index) {
    return item.show && /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      button: true,
      key: item.id,
      selected: index === selectedTab,
      disableRipple: true,
      onClick: function onClick() {
        return handleItemClick(index, item.id, item.onClick);
      },
      classes: {
        selected: classes.listItemSelected,
        root: classes.listItemRoot
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: item.titulo,
      classes: {
        primary: "".concat(classes.listItemText, " ").concat(index === selectedTab ? classes.listItemTextSelected : '')
      }
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.rigthBox
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.fixedHeader
  }, notificacaoSuperior && /*#__PURE__*/_react["default"].createElement(_SttNotification["default"], {
    severity: notificacaoSuperior.severity || "info",
    className: classes.alert
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.notification,
    dangerouslySetInnerHTML: {
      __html: notificacaoSuperior.conteudo
    }
  })), /*#__PURE__*/_react["default"].createElement(_SttContainerTitle["default"], {
    botaoAcoes: botaoAcoes,
    onClickVoltar: onClickVoltar,
    botoes: botoes,
    titulo: titulo,
    formRef: formRef
  })), conteudoLateral ? /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    container: true,
    className: classes.contentWithAside
  }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    item: true,
    md: 8,
    xs: 12
  }, conteudoMain), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    item: true,
    md: 4,
    className: classes.lateralContent
  }, conteudoLateral)) : conteudoMain, conteudoLateral && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
    color: "primary",
    className: classes.fabPreVisualizacao,
    onClick: function onClick() {
      return setModalPreVisualizacao(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Visibility["default"], null)), /*#__PURE__*/_react["default"].createElement(_SttModal["default"], {
    title: titulo,
    open: modalPreVisualizacao,
    outModalClose: function outModalClose() {
      return setModalPreVisualizacao(false);
    },
    iconClose: function iconClose() {
      return setModalPreVisualizacao(false);
    },
    maxWidth: "sm",
    fullWidth: true
  }, conteudoLateral))));
});
var _default = SttContentDrawer;
exports["default"] = _default;